import { useState } from "react";
import InputData from "./InputData";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import { userData, selectedOptic } from "../js/utils";
import { post } from "../js/post";
import "../css/ProductStockAdjustment.css";
import { useOptics } from "../hooks/useOptics";

export default function ProductStockTransfer(props) {
  const opticalList = useOptics().filter((e) => e.id !== selectedOptic.id);
  const [selectedDestinationOptic, setSelectedDestinationOptic] = useState("");
  const [stock, setStock] = useState(0);

  async function transferProductStock() {
    if (stock > 0) {
      await post("TraspasarStockProducto.php", {
        token: userData.token,
        codigo: props.productCode,
        idOptica: selectedOptic.id,
        opticaDestino: selectedDestinationOptic,
        stock: stock,
      });
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        alignItems: "center",
      }}
    >
      <div className="product-stock-container">
        <button
          onClick={() => {
            setStock(stock > 0 ? stock - 1 : 0);
          }}
        >
          -
        </button>
        <div className="data-field">
          <InputData
            tabIndex={10}
            type="type-positive-integer"
            size={5}
            input={stock}
            onChange={(e) => {
              const val = e === "" ? 0 : parseInt(e);
              setStock(Math.min(val, props.stock));
            }}
            onBlur={(val) => {
              setStock(Math.min(parseInt(val) || 0, props.stock));
            }}
          ></InputData>
        </div>
        <button
          onClick={() => {
            setStock(stock < props.stock ? stock + 1 : stock);
          }}
        >
          +
        </button>
      </div>
      <div className="data-field">
        <span className="cell-label">Óptica</span>
        <Dropdown
          tabIndex={7}
          id="provincia"
          disabled={false}
          optionList={opticalList}
          size={2}
          op={selectedDestinationOptic}
          onChange={(e) => {
            setSelectedDestinationOptic(e.id);
          }}
        ></Dropdown>
      </div>
      <ButtonIconH
        text="Aceptar"
        small={true}
        disabled={stock === 0 || !selectedDestinationOptic}
        onClick={async () => {
          await transferProductStock();
          props.onAccept();
          props.createPopupQuestion(
            "El traspaso de stock se ha realizado correctamente. Puede consultarse en la sección de trazabilidad del producto.",
            () => {
              props.removePopupQuestion();
              setSelectedDestinationOptic("");
              setStock(0);
            },
            null,
            "Aceptar",
          );
        }}
      ></ButtonIconH>
    </div>
  );
}
